<template lang='pug'>
  //- Rank-Page
  div(:class='$style[`cc-rank-container`]')
    div(:class='$style[`cc-rank-banner`]')
      div(:class='$style[`cc-banner-title`]')
        span.font-bold(:class='$style[`cc-banner-main-title`]')
          span.font-doctor-theme(v-html='`經驗`')
          span.font-normal-theme(v-html='`值`')
          IconRank(:size='80')
          span.no-wrap(v-html='`排行榜`')

        div.font-medium(:class='$style[`cc-banner-sub-title`]')
          span!= '從互動中累積經驗值，提升你的排名'
          router-link(
            tag='span'
            role='button'
            tabindex='0'
            aria-label='看說明'
            to='/tutorial#rank'
            :class='$style[`cc-banner-sub-title-tip`]')
            IconInfo(:size='20' :color='`#b1b1b1`')
            !='看說明'
          //- span
          //-   != '從互動中累積經驗值，提升你的排名。 '
          //-   router-link(
          //-     tag='span'
          //-     to='/tutorial#rank'
          //-     :class='$style[`cc-banner-sub-title-tip`]')
          //-     IconInfo(:size='20' :color='`#b1b1b1`')
          //-     !='看說明'

    //- 選單區
    div(:class='[$style[`cc-rank-menu`], $style[stateFlowBarFixed ? `flowBar-fixed` : ``]]')
      div(:class='$style[`cc-rank-menu-wrap`]')
        nav(:class='[$style[`cc-rank-menu-nav`], $style[switchType === `normal` ? `js-selected` : ``]]' @click='switchTypeOnClick(`normal`)')
          span!= '普通會員'
            //- span.no-wrap!= '排名'

        nav(:class='[$style[`cc-rank-menu-nav`], $style[switchType === `doctor` ? `js-selected` : ``]]' @click='switchTypeOnClick(`doctor`)')
          span!= '醫護會員'
            //- span.no-wrap!= '排名'

        router-link(
          tag='nav'
          role='button'
          tabindex='0'
          aria-label='C幣換好康'
          to='/shop/stuff'
          :class='[$style[`cc-rank-menu-nav`], $style[switchType === `shop` ? `js-selected` : ``]]')
          span
            IconCcoin(:size='24')
            != '幣換好康'

    div(:class='$style[`cc-rank-wrap`]')
      RankList(v-if='switchType === `normal` || switchType === `doctor`' :key='`${nextTick}-rl`' :listType='switchType')


</template>

<script>
import { mapGetters } from 'vuex';
import IconRank from '../../icon/Rank';
import IconCcoin from '../../icon/Ccoin';
import IconInfo from '../../icon/Info';
import RankList from './RankList.vue';

export default {
  metaInfo() {
    return {
      title: '排行榜',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/rank',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/rank',
      }],
    };
  },

  components: {
    IconRank,
    IconCcoin,
    RankList,
    IconInfo,
  },

  data() {
    return {
      switchType: 'normal',
      nextTick: 1,
    };
  },

  methods: {
    switchTypeOnClick(type) {
      this.switchType = type;
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // rwdType: 'global/exportRwdType',
      // authJwtToken: 'user/exportUserJwtToken',
      // loginStatus: 'user/exportLoginStatus',
      // loginHashCode: 'user/exportUserHashCode',
      // loginProfile: 'user/exportUserProfile',
      stateFlowBarFixed: 'global/exportFlowBarFixed',
      // stateIndexBanner: 'global/exportIndexBanner',
      // stateIndexFlowType: 'flow/exportIndexFlowType',
      // stateIndexFilterType: 'flow/exportIndexFilterType',
      // stateIndexFlowArticleData: 'flow/exportIndexFlowTypeArticle',
      // stateIndexFlowResumeData: 'flow/exportIndexFlowTypeResume',
      // stateIndexFlowQaData: 'flow/exportIndexFlowTypeQa',
      // stateIndexFlowTags: 'flow/exportIndexFlowTags',
    }),
  },

  // eslint-disable-next-line vue/order-in-components
  watch: {
    switchType() {
      this.nextTick += 1;
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/rank/rank.scss';
</style>
